// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/sharepoint/v1/sharepoint.proto (package mono.sharepoint.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Struct, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.sharepoint.v1.CheckDocumentPermissionRequest
 */ export class CheckDocumentPermissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new CheckDocumentPermissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckDocumentPermissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckDocumentPermissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckDocumentPermissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string resource_id = 3;
   */ _define_property(this, "resourceId", ""), /**
   * @generated from field: string access_token = 4;
   */ _define_property(this, "accessToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckDocumentPermissionRequest, "runtime", proto3);
_define_property(CheckDocumentPermissionRequest, "typeName", "mono.sharepoint.v1.CheckDocumentPermissionRequest");
_define_property(CheckDocumentPermissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "resource_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "access_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.CheckDocumentPermissionResponse
 */ export class CheckDocumentPermissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new CheckDocumentPermissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CheckDocumentPermissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CheckDocumentPermissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CheckDocumentPermissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool allowed = 1;
   */ _define_property(this, "allowed", false), /**
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: bool cached = 3;
   */ _define_property(this, "cached", false), /**
   * @generated from field: google.protobuf.Timestamp checked_at = 4;
   */ _define_property(this, "checkedAt", void 0), /**
   * @generated from field: google.protobuf.Struct metadata = 5;
   */ _define_property(this, "metadata", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CheckDocumentPermissionResponse, "runtime", proto3);
_define_property(CheckDocumentPermissionResponse, "typeName", "mono.sharepoint.v1.CheckDocumentPermissionResponse");
_define_property(CheckDocumentPermissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "allowed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "cached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "checked_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "metadata",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.BatchCheckDocumentPermissionRequest
 */ export class BatchCheckDocumentPermissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new BatchCheckDocumentPermissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BatchCheckDocumentPermissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BatchCheckDocumentPermissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BatchCheckDocumentPermissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: repeated string resource_ids = 3;
   */ _define_property(this, "resourceIds", []), /**
   * @generated from field: string access_token = 4;
   */ _define_property(this, "accessToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BatchCheckDocumentPermissionRequest, "runtime", proto3);
_define_property(BatchCheckDocumentPermissionRequest, "typeName", "mono.sharepoint.v1.BatchCheckDocumentPermissionRequest");
_define_property(BatchCheckDocumentPermissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "resource_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "access_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.BatchCheckDocumentPermissionResponse
 */ export class BatchCheckDocumentPermissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new BatchCheckDocumentPermissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BatchCheckDocumentPermissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BatchCheckDocumentPermissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BatchCheckDocumentPermissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: map<string, mono.sharepoint.v1.PermissionResult> results = 1;
   */ _define_property(this, "results", {}), /**
   * @generated from field: google.protobuf.Timestamp checked_at = 2;
   */ _define_property(this, "checkedAt", void 0), /**
   * @generated from field: int32 total_checked = 3;
   */ _define_property(this, "totalChecked", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BatchCheckDocumentPermissionResponse, "runtime", proto3);
_define_property(BatchCheckDocumentPermissionResponse, "typeName", "mono.sharepoint.v1.BatchCheckDocumentPermissionResponse");
_define_property(BatchCheckDocumentPermissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "results",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "message",
                T: PermissionResult
            }
        },
        {
            no: 2,
            name: "checked_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "total_checked",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.PermissionResult
 */ export class PermissionResult extends Message {
    static fromBinary(bytes, options) {
        return new PermissionResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PermissionResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PermissionResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PermissionResult, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool allowed = 1;
   */ _define_property(this, "allowed", false), /**
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: bool cached = 3;
   */ _define_property(this, "cached", false), /**
   * @generated from field: google.protobuf.Timestamp checked_at = 4;
   */ _define_property(this, "checkedAt", void 0), /**
   * @generated from field: google.protobuf.Struct metadata = 5;
   */ _define_property(this, "metadata", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PermissionResult, "runtime", proto3);
_define_property(PermissionResult, "typeName", "mono.sharepoint.v1.PermissionResult");
_define_property(PermissionResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "allowed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "cached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "checked_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "metadata",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.GetUserSiteAccessRequest
 */ export class GetUserSiteAccessRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetUserSiteAccessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetUserSiteAccessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetUserSiteAccessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetUserSiteAccessRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string access_token = 3;
   */ _define_property(this, "accessToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetUserSiteAccessRequest, "runtime", proto3);
_define_property(GetUserSiteAccessRequest, "typeName", "mono.sharepoint.v1.GetUserSiteAccessRequest");
_define_property(GetUserSiteAccessRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "access_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.GetUserSiteAccessResponse
 */ export class GetUserSiteAccessResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetUserSiteAccessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetUserSiteAccessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetUserSiteAccessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetUserSiteAccessResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: repeated mono.sharepoint.v1.SitePermission sites = 3;
   */ _define_property(this, "sites", []), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetUserSiteAccessResponse, "runtime", proto3);
_define_property(GetUserSiteAccessResponse, "typeName", "mono.sharepoint.v1.GetUserSiteAccessResponse");
_define_property(GetUserSiteAccessResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sites",
            kind: "message",
            T: SitePermission,
            repeated: true
        },
        {
            no: 4,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.SitePermission
 */ export class SitePermission extends Message {
    static fromBinary(bytes, options) {
        return new SitePermission().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SitePermission().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SitePermission().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SitePermission, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string site_id = 1;
   */ _define_property(this, "siteId", ""), /**
   * @generated from field: string site_name = 2;
   */ _define_property(this, "siteName", ""), /**
   * @generated from field: string site_url = 3;
   */ _define_property(this, "siteUrl", ""), /**
   * @generated from field: string permission_level = 4;
   */ _define_property(this, "permissionLevel", ""), /**
   * @generated from field: repeated string roles = 5;
   */ _define_property(this, "roles", []), /**
   * @generated from field: google.protobuf.Timestamp last_checked = 6;
   */ _define_property(this, "lastChecked", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SitePermission, "runtime", proto3);
_define_property(SitePermission, "typeName", "mono.sharepoint.v1.SitePermission");
_define_property(SitePermission, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "site_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "site_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "site_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "permission_level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "roles",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "last_checked",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.Document
 */ export class Document extends Message {
    static fromBinary(bytes, options) {
        return new Document().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Document().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Document().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Document, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string resource_id = 3;
   */ _define_property(this, "resourceId", ""), /**
   * @generated from field: google.protobuf.Struct metadata = 4;
   */ _define_property(this, "metadata", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Document, "runtime", proto3);
_define_property(Document, "typeName", "mono.sharepoint.v1.Document");
_define_property(Document, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "resource_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "metadata",
            kind: "message",
            T: Struct
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.FilterDocumentsByACLRequest
 */ export class FilterDocumentsByACLRequest extends Message {
    static fromBinary(bytes, options) {
        return new FilterDocumentsByACLRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FilterDocumentsByACLRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FilterDocumentsByACLRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FilterDocumentsByACLRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: repeated mono.sharepoint.v1.Document documents = 3;
   */ _define_property(this, "documents", []), /**
   * @generated from field: string access_token = 4;
   */ _define_property(this, "accessToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FilterDocumentsByACLRequest, "runtime", proto3);
_define_property(FilterDocumentsByACLRequest, "typeName", "mono.sharepoint.v1.FilterDocumentsByACLRequest");
_define_property(FilterDocumentsByACLRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "documents",
            kind: "message",
            T: Document,
            repeated: true
        },
        {
            no: 4,
            name: "access_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.FilterDocumentsByACLResponse
 */ export class FilterDocumentsByACLResponse extends Message {
    static fromBinary(bytes, options) {
        return new FilterDocumentsByACLResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FilterDocumentsByACLResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FilterDocumentsByACLResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FilterDocumentsByACLResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.sharepoint.v1.Document authorized_documents = 1;
   */ _define_property(this, "authorizedDocuments", []), /**
   * @generated from field: int32 total_requested = 2;
   */ _define_property(this, "totalRequested", 0), /**
   * @generated from field: int32 total_authorized = 3;
   */ _define_property(this, "totalAuthorized", 0), /**
   * @generated from field: int32 total_denied = 4;
   */ _define_property(this, "totalDenied", 0), /**
   * @generated from field: int64 filter_time_ms = 5;
   */ _define_property(this, "filterTimeMs", protoInt64.zero), /**
   * @generated from field: int32 cache_hits = 6;
   */ _define_property(this, "cacheHits", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FilterDocumentsByACLResponse, "runtime", proto3);
_define_property(FilterDocumentsByACLResponse, "typeName", "mono.sharepoint.v1.FilterDocumentsByACLResponse");
_define_property(FilterDocumentsByACLResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "authorized_documents",
            kind: "message",
            T: Document,
            repeated: true
        },
        {
            no: 2,
            name: "total_requested",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "total_authorized",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "total_denied",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "filter_time_ms",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "cache_hits",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.GenerateOAuthStateRequest
 */ export class GenerateOAuthStateRequest extends Message {
    static fromBinary(bytes, options) {
        return new GenerateOAuthStateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateOAuthStateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateOAuthStateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateOAuthStateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string redirect_uri = 3;
   */ _define_property(this, "redirectUri", ""), /**
   * OAuth config fields (passed by caller from mariejois)
   *
   * @generated from field: string client_id = 4;
   */ _define_property(this, "clientId", ""), /**
   * @generated from field: string authority = 5;
   */ _define_property(this, "authority", ""), /**
   * @generated from field: string scope = 6;
   */ _define_property(this, "scope", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateOAuthStateRequest, "runtime", proto3);
_define_property(GenerateOAuthStateRequest, "typeName", "mono.sharepoint.v1.GenerateOAuthStateRequest");
_define_property(GenerateOAuthStateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "redirect_uri",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "client_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "authority",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.GenerateOAuthStateResponse
 */ export class GenerateOAuthStateResponse extends Message {
    static fromBinary(bytes, options) {
        return new GenerateOAuthStateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateOAuthStateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateOAuthStateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateOAuthStateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string authorization_url = 1;
   */ _define_property(this, "authorizationUrl", ""), /**
   * @generated from field: string state = 2;
   */ _define_property(this, "state", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateOAuthStateResponse, "runtime", proto3);
_define_property(GenerateOAuthStateResponse, "typeName", "mono.sharepoint.v1.GenerateOAuthStateResponse");
_define_property(GenerateOAuthStateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "authorization_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.ExchangeOAuthCodeRequest
 */ export class ExchangeOAuthCodeRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExchangeOAuthCodeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExchangeOAuthCodeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExchangeOAuthCodeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExchangeOAuthCodeRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string code = 3;
   */ _define_property(this, "code", ""), /**
   * @generated from field: string state = 4;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string redirect_uri = 5;
   */ _define_property(this, "redirectUri", ""), /**
   * OAuth config fields (passed by caller from mariejois)
   *
   * @generated from field: string client_id = 6;
   */ _define_property(this, "clientId", ""), /**
   * @generated from field: string client_secret = 7;
   */ _define_property(this, "clientSecret", ""), /**
   * @generated from field: string authority = 8;
   */ _define_property(this, "authority", ""), /**
   * @generated from field: string scope = 9;
   */ _define_property(this, "scope", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExchangeOAuthCodeRequest, "runtime", proto3);
_define_property(ExchangeOAuthCodeRequest, "typeName", "mono.sharepoint.v1.ExchangeOAuthCodeRequest");
_define_property(ExchangeOAuthCodeRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "redirect_uri",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "client_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "client_secret",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "authority",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.ExchangeOAuthCodeResponse
 */ export class ExchangeOAuthCodeResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExchangeOAuthCodeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExchangeOAuthCodeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExchangeOAuthCodeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExchangeOAuthCodeResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool success = 1;
   */ _define_property(this, "success", false), /**
   * @generated from field: string error = 2;
   */ _define_property(this, "error", ""), /**
   * @generated from field: string access_token = 3;
   */ _define_property(this, "accessToken", ""), /**
   * @generated from field: string refresh_token = 4;
   */ _define_property(this, "refreshToken", ""), /**
   * @generated from field: int64 expires_in = 5;
   */ _define_property(this, "expiresIn", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExchangeOAuthCodeResponse, "runtime", proto3);
_define_property(ExchangeOAuthCodeResponse, "typeName", "mono.sharepoint.v1.ExchangeOAuthCodeResponse");
_define_property(ExchangeOAuthCodeResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "success",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "access_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "refresh_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "expires_in",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.GetSessionRequest
 */ export class GetSessionRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetSessionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSessionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSessionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSessionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSessionRequest, "runtime", proto3);
_define_property(GetSessionRequest, "typeName", "mono.sharepoint.v1.GetSessionRequest");
_define_property(GetSessionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.GetSessionResponse
 */ export class GetSessionResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetSessionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSessionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSessionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSessionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool connected = 1;
   */ _define_property(this, "connected", false), /**
   * @generated from field: int64 expires_at = 2;
   */ _define_property(this, "expiresAt", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSessionResponse, "runtime", proto3);
_define_property(GetSessionResponse, "typeName", "mono.sharepoint.v1.GetSessionResponse");
_define_property(GetSessionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "connected",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "expires_at",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.RevokeSessionRequest
 */ export class RevokeSessionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RevokeSessionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RevokeSessionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RevokeSessionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RevokeSessionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RevokeSessionRequest, "runtime", proto3);
_define_property(RevokeSessionRequest, "typeName", "mono.sharepoint.v1.RevokeSessionRequest");
_define_property(RevokeSessionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.RevokeSessionResponse
 */ export class RevokeSessionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RevokeSessionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RevokeSessionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RevokeSessionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RevokeSessionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool success = 1;
   */ _define_property(this, "success", false), /**
   * @generated from field: string message = 2;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RevokeSessionResponse, "runtime", proto3);
_define_property(RevokeSessionResponse, "typeName", "mono.sharepoint.v1.RevokeSessionResponse");
_define_property(RevokeSessionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "success",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.DriveInfo
 */ export class DriveInfo extends Message {
    static fromBinary(bytes, options) {
        return new DriveInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DriveInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DriveInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DriveInfo, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string drive_type = 3;
   */ _define_property(this, "driveType", ""), /**
   * @generated from field: string web_url = 4;
   */ _define_property(this, "webUrl", ""), /**
   * @generated from field: int64 total_size = 5;
   */ _define_property(this, "totalSize", protoInt64.zero), /**
   * @generated from field: int64 used_size = 6;
   */ _define_property(this, "usedSize", protoInt64.zero), /**
   * @generated from field: int64 item_count = 7;
   */ _define_property(this, "itemCount", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DriveInfo, "runtime", proto3);
_define_property(DriveInfo, "typeName", "mono.sharepoint.v1.DriveInfo");
_define_property(DriveInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "drive_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "web_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "total_size",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "used_size",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 7,
            name: "item_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.ListSiteDrivesRequest
 */ export class ListSiteDrivesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSiteDrivesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSiteDrivesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSiteDrivesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSiteDrivesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string site_id = 3;
   */ _define_property(this, "siteId", ""), /**
   * @generated from field: string access_token = 4;
   */ _define_property(this, "accessToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSiteDrivesRequest, "runtime", proto3);
_define_property(ListSiteDrivesRequest, "typeName", "mono.sharepoint.v1.ListSiteDrivesRequest");
_define_property(ListSiteDrivesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "site_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "access_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.ListSiteDrivesResponse
 */ export class ListSiteDrivesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSiteDrivesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSiteDrivesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSiteDrivesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSiteDrivesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.sharepoint.v1.DriveInfo drives = 1;
   */ _define_property(this, "drives", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSiteDrivesResponse, "runtime", proto3);
_define_property(ListSiteDrivesResponse, "typeName", "mono.sharepoint.v1.ListSiteDrivesResponse");
_define_property(ListSiteDrivesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "drives",
            kind: "message",
            T: DriveInfo,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.DriveItem
 */ export class DriveItem extends Message {
    static fromBinary(bytes, options) {
        return new DriveItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DriveItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DriveItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DriveItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string web_url = 3;
   */ _define_property(this, "webUrl", ""), /**
   * @generated from field: int64 size = 4;
   */ _define_property(this, "size", protoInt64.zero), /**
   * @generated from field: string mime_type = 5;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: bool is_folder = 6;
   */ _define_property(this, "isFolder", false), /**
   * @generated from field: int32 child_count = 7;
   */ _define_property(this, "childCount", 0), /**
   * @generated from field: string created_by = 8;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: string last_modified_by = 9;
   */ _define_property(this, "lastModifiedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp modified_at = 11;
   */ _define_property(this, "modifiedAt", void 0), /**
   * @generated from field: string drive_id = 12;
   */ _define_property(this, "driveId", ""), /**
   * @generated from field: string site_id = 13;
   */ _define_property(this, "siteId", ""), /**
   * @generated from field: string parent_path = 14;
   */ _define_property(this, "parentPath", ""), /**
   * @generated from field: string resource_id = 15;
   */ _define_property(this, "resourceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DriveItem, "runtime", proto3);
_define_property(DriveItem, "typeName", "mono.sharepoint.v1.DriveItem");
_define_property(DriveItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "web_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "size",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "is_folder",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "child_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "last_modified_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "modified_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "drive_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "site_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "parent_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "resource_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.ListDriveItemsRequest
 */ export class ListDriveItemsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDriveItemsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDriveItemsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDriveItemsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDriveItemsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string drive_id = 3;
   */ _define_property(this, "driveId", ""), /**
   * @generated from field: string item_id = 4;
   */ _define_property(this, "itemId", ""), /**
   * @generated from field: string access_token = 5;
   */ _define_property(this, "accessToken", ""), /**
   * @generated from field: int32 page_size = 6;
   */ _define_property(this, "pageSize", 0), /**
   * @generated from field: string page_token = 7;
   */ _define_property(this, "pageToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDriveItemsRequest, "runtime", proto3);
_define_property(ListDriveItemsRequest, "typeName", "mono.sharepoint.v1.ListDriveItemsRequest");
_define_property(ListDriveItemsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "drive_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "access_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.ListDriveItemsResponse
 */ export class ListDriveItemsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDriveItemsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDriveItemsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDriveItemsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDriveItemsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.sharepoint.v1.DriveItem items = 1;
   */ _define_property(this, "items", []), /**
   * @generated from field: string next_page_token = 2;
   */ _define_property(this, "nextPageToken", ""), /**
   * @generated from field: int32 total_count = 3;
   */ _define_property(this, "totalCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDriveItemsResponse, "runtime", proto3);
_define_property(ListDriveItemsResponse, "typeName", "mono.sharepoint.v1.ListDriveItemsResponse");
_define_property(ListDriveItemsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "items",
            kind: "message",
            T: DriveItem,
            repeated: true
        },
        {
            no: 2,
            name: "next_page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "total_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.GetDriveItemContentRequest
 */ export class GetDriveItemContentRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDriveItemContentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDriveItemContentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDriveItemContentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDriveItemContentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string site_id = 3;
   */ _define_property(this, "siteId", ""), /**
   * @generated from field: string drive_id = 4;
   */ _define_property(this, "driveId", ""), /**
   * @generated from field: string item_id = 5;
   */ _define_property(this, "itemId", ""), /**
   * @generated from field: string access_token = 6;
   */ _define_property(this, "accessToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDriveItemContentRequest, "runtime", proto3);
_define_property(GetDriveItemContentRequest, "typeName", "mono.sharepoint.v1.GetDriveItemContentRequest");
_define_property(GetDriveItemContentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "site_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "drive_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "access_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.GetDriveItemContentResponse
 */ export class GetDriveItemContentResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDriveItemContentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDriveItemContentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDriveItemContentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDriveItemContentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bytes content = 1;
   */ _define_property(this, "content", new Uint8Array(0)), /**
   * @generated from field: string file_name = 2;
   */ _define_property(this, "fileName", ""), /**
   * @generated from field: string mime_type = 3;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: int64 size = 4;
   */ _define_property(this, "size", protoInt64.zero), /**
   * @generated from field: string download_url = 5;
   */ _define_property(this, "downloadUrl", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDriveItemContentResponse, "runtime", proto3);
_define_property(GetDriveItemContentResponse, "typeName", "mono.sharepoint.v1.GetDriveItemContentResponse");
_define_property(GetDriveItemContentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "content",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        },
        {
            no: 2,
            name: "file_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "size",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "download_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.SearchDocumentsRequest
 */ export class SearchDocumentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new SearchDocumentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchDocumentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchDocumentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchDocumentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string query = 3;
   */ _define_property(this, "query", ""), /**
   * @generated from field: string access_token = 4;
   */ _define_property(this, "accessToken", ""), /**
   * @generated from field: int32 page_size = 5;
   */ _define_property(this, "pageSize", 0), /**
   * @generated from field: int32 offset = 6;
   */ _define_property(this, "offset", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchDocumentsRequest, "runtime", proto3);
_define_property(SearchDocumentsRequest, "typeName", "mono.sharepoint.v1.SearchDocumentsRequest");
_define_property(SearchDocumentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "access_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.SearchHit
 */ export class SearchHit extends Message {
    static fromBinary(bytes, options) {
        return new SearchHit().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchHit().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchHit().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchHit, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string hit_id = 1;
   */ _define_property(this, "hitId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string web_url = 3;
   */ _define_property(this, "webUrl", ""), /**
   * @generated from field: string summary = 4;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: string site_id = 5;
   */ _define_property(this, "siteId", ""), /**
   * @generated from field: string drive_id = 6;
   */ _define_property(this, "driveId", ""), /**
   * @generated from field: string item_id = 7;
   */ _define_property(this, "itemId", ""), /**
   * @generated from field: string resource_id = 8;
   */ _define_property(this, "resourceId", ""), /**
   * @generated from field: int64 size = 9;
   */ _define_property(this, "size", protoInt64.zero), /**
   * @generated from field: string mime_type = 10;
   */ _define_property(this, "mimeType", ""), /**
   * @generated from field: string last_modified_by = 11;
   */ _define_property(this, "lastModifiedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp modified_at = 12;
   */ _define_property(this, "modifiedAt", void 0), /**
   * @generated from field: double rank = 13;
   */ _define_property(this, "rank", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchHit, "runtime", proto3);
_define_property(SearchHit, "typeName", "mono.sharepoint.v1.SearchHit");
_define_property(SearchHit, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "hit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "web_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "site_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "drive_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "resource_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "size",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 10,
            name: "mime_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "last_modified_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "modified_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "rank",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.sharepoint.v1.SearchDocumentsResponse
 */ export class SearchDocumentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new SearchDocumentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchDocumentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchDocumentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchDocumentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.sharepoint.v1.SearchHit hits = 1;
   */ _define_property(this, "hits", []), /**
   * @generated from field: int32 total_count = 2;
   */ _define_property(this, "totalCount", 0), /**
   * @generated from field: bool more_results_available = 3;
   */ _define_property(this, "moreResultsAvailable", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchDocumentsResponse, "runtime", proto3);
_define_property(SearchDocumentsResponse, "typeName", "mono.sharepoint.v1.SearchDocumentsResponse");
_define_property(SearchDocumentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "hits",
            kind: "message",
            T: SearchHit,
            repeated: true
        },
        {
            no: 2,
            name: "total_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "more_results_available",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
